
    export function _create_style_sheet(s) {
        const sheet = new CSSStyleSheet;
        sheet.replaceSync(s);
        return sheet;
    }
